import React, {
    useEffect,
    useState
} from "react";

import axios from "axios";

import {
    Trophy,
    Zap,
    Brain,
    Flame,
    Play
} from "lucide-react";

import {
    useNavigate
} from "react-router-dom";

import "./ArenaHero.css";


const ArenaHero = () => {

    const navigate = useNavigate();

    const email =
        localStorage.getItem(
            "user_email"
        );

    const [
        dashboard,
        setDashboard
    ] = useState(null);


    useEffect(() => {

        if (email) {

            loadDashboard();

        }

    }, [email]);


    const loadDashboard = async () => {

        try {

            const res =
                await axios.get(
                    `/api/dashboard/${email}`
                );

            setDashboard(
                res.data
            );

        }

        catch (err) {

            console.error(
                "Arena dashboard error:",
                err
            );

        }

    };


    

    if (!dashboard) {

        return (

            <div className="arena-hero arena-loading">

                Loading...

            </div>

        );

    }


    return (

        <div className="arena-hero">

            {/* ================= LEFT ================= */}

            <div className="arena-left">

                <span className="arena-badge">

                    🏟 Ignite Arena

                </span>


                <h1>

                    Train. Improve. Dominate.

                </h1>


                <p>

                    Practice your cognitive skills,
                    improve every session, and climb
                    the leaderboard for every Ignite
                    assessment.

                </p>


               

            </div>


            {/* ================= RIGHT ================= */}

            <div className="arena-right">


                <div className="arena-stat">

                    <div className="arena-stat-icon">

                        <Zap size={24} />

                    </div>

                    <div className="arena-stat-content">

                        <h2>
                            9
                        </h2>

                        <span>
                            Practice Modes
                        </span>

                    </div>

                </div>


                <div className="arena-stat">

                    <div className="arena-stat-icon">

                        <Trophy size={24} />

                    </div>

                    <div className="arena-stat-content">

                        <h2>
                            8
                        </h2>

                        <span>
                            Leaderboards
                        </span>

                    </div>

                </div>


                <div className="arena-stat">

                    <div className="arena-stat-icon">

                        <Brain size={24} />

                    </div>

                    <div className="arena-stat-content">

                        <h2>

                            {
                                dashboard.totalTestsCompleted
                            }

                        </h2>

                        <span>
                            Assessments
                        </span>

                    </div>

                </div>


                <div className="arena-stat">

                    <div className="arena-stat-icon">

                        <Flame size={24} />

                    </div>

                    <div className="arena-stat-content">

                        <h2>

                            {
                                dashboard.dailyStreak
                            }

                        </h2>

                        <span>
                            Day Streak
                        </span>

                    </div>

                </div>


            </div>

        </div>

    );

};


export default ArenaHero;